import { articleStore } from '@/store';
import {
    ADBLOCK_EXOCLICK,
    DEFAULT_TRAFFIC_SOURCE,
    TRAFFIC_SOURCE_EXOCLICK,
} from '@/constants';
import { facebookMixin } from './facebook';
import { adSenseLogic } from '@/mixins/components/adsense';
import { mediaQueriesMixin } from '@/mixins/mediaQueries';
import { getCategory } from '@/services/top5-v2-1/get-category';
import { helper } from '@/mixins/helper';

export const articlesMixin = {
    mixins: [facebookMixin, mediaQueriesMixin, adSenseLogic, helper],
    data() {
        return {
            articles: [],
            articleState: articleStore.state,
            article: [],
            articleSections: [],
            topArticles: [],
            loaded: false,
        };
    },
    mounted() {
        if (this.$route.name === 'article') {
            this.getArticle(this.$route.params.id);
        }
    },
    updated() {
        this.$globalConstants.host['article_cta_text'] && this.displayBtnText();
    },
    watch: {
        $route() {
            if (this.$route.name === 'article') {
                this.getArticle(this.$route.params.id);
            }
        },
    },
    methods: {
        async getArticle(articleId) {
            this.loaded = false;
            let trafficSource = DEFAULT_TRAFFIC_SOURCE;

            if (!articleId) {
                articleId = this.$route.params.id;
            }

            if (this.$globalState.trafficSource !== null) {
                trafficSource = this.$globalState.trafficSource;
            } else {
                trafficSource = document
                    .querySelector('#main-ts')
                    .getAttribute('data-ts');
                this.$globalState.trafficSource = trafficSource;
            }

            if (TRAFFIC_SOURCE_EXOCLICK === trafficSource) {
                trafficSource = ADBLOCK_EXOCLICK;
            }

            let url = `/host/${this.$globalConstants.host['id']}/article/${articleId}/${trafficSource}`;
            url = url + '?device_type=' + this.$globalConstants.deviceType;

            if (!articleId) {
                return;
            }

            window.axios.get(url).then(async (response) => {
                this.loaded = true;
                if (!response.data.article) return;
                let article = response.data.article;

                if (this.injectRankingList) {
                    article = await this.injectRankingList(article);
                }

                // @todo testing psi score without external style sheet
                if (
                    this.$globalConstants['host']['name'] === 'datingsider.no'
                ) {
                    article['is_content_creator_styling'] = false;
                }

                this.loadArticleEditorStyleSheet(article);

                this.article = this.updateImageUrls(article);

                document.title = article.title;
                if (article['canonical']) {
                    document.getElementById('canonical').href =
                        article['canonical'];
                }

                if (article['json_ld']) {
                    document.getElementById('jsonLD').text = article['json_ld'];
                }
            });

            if (window.track) {
                window.track.pageview(`/article/${articleId}`);
            } else {
                this.$ga.page(`/article/${articleId}`);
            }
        },
        async injectRankingList(article) {
            let content = article['content'];
            if (!content) return article;

            const categoryRegex = /"[^"]+"/;
            const rankingRegExp = /\[ranking_list category="[^\]]*"]/g;
            const replaceHolder = '<ranking-list/>';

            const rankingListElements = [...content.matchAll(rankingRegExp)];
            article.contentRankingList = [];

            for (let i = 0; i < rankingListElements.length; i++) {
                const item = rankingListElements[i][0]; // placeholder
                const categorySlug = item
                    .match(categoryRegex)[0]
                    .replaceAll('"', ''); // extract category from placeholder

                article.contentRankingList.push(
                    await this.getRankingListByCategory(categorySlug)
                );
                content = content.replace(item, replaceHolder);
            }

            if (article.contentRankingList.length > 0) {
                article.content = content.split(replaceHolder);
            }

            return article;
        },
        async getRankingListByCategory(slug) {
            const data = await getCategory({
                category: slug,
                hasAbRank: Boolean(this.$route.query.arnk),
                fixedPosition: this.$globalState.fixedPosition,
                boostRankingVersion: this.$route.query.brnkv,
                boostRanking: this.$route.query.brnk,
                start: '1',
                length: '3',
            });

            this.psh = data['partnerSet'];

            return data['partners'];
        },
        getArticles() {
            if (!this.articleState.articles) {
                window.axios
                    .get(`/host/${this.$globalConstants.host['id']}/articles`)
                    .then((response) => {
                        this.loaded = true;
                        this.articles = response.data.articles.sort(
                            (a, b) =>
                                new Date(b.updated_at) - new Date(a.updated_at)
                        );
                        articleStore.setArticles(this.articles);
                    });
            } else {
                this.loaded = true;
            }

            if (window.track) {
                window.track.pageview(`/articles`);
            } else {
                this.$ga.page(`/articles`);
            }
        },
        getArticleSections() {
            window.axios
                .get(
                    `/host/${this.$globalConstants.host['id']}/articles?include_reviews=1`
                )
                .then((response) => {
                    if (response.data['article_sections']) {
                        this.articleSections =
                            response.data['article_sections'];
                    }
                    this.loaded = true;
                });
        },
        async getTopArticles() {
            window.axios
                .get(`/host/${this.$globalConstants.host['id']}/top-articles`)
                .then((response) => {
                    this.loaded = true;
                    this.topArticles = response.data.articles.sort(
                        (a, b) => b.id - a.id
                    );
                });
        },
        getArticlesByID(id) {
            let url = `/host/${this.$globalConstants.host['id']}/articles/slug/${id}`;
            console.log(typeof id, this.isNumericString(id));
            if (this.isNumericString(id)) {
                url = `/host/${this.$globalConstants.host['id']}/articles/${id}`;
            }

            axios.get(url).then((response) => {
                this.articles = response.data.articles.sort(
                    (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
                );
                this.loaded = true;
            });
        },
        partnerScore(partner) {
            let score = partner.score;
            if (score.toString().length < 2) {
                score = score + '.0';
            }
            return score.toString();
        },
        displayBtnText() {
            let elClass = document.getElementsByClassName('inline-cms-button');

            Array.from(elClass).forEach((item) => {
                item.innerHTML = this.$globalConstants.host['article_cta_text'];
            });
        },
    },
};
